import { ReactiveController, ReactiveControllerHost } from "lit"
import { getElementsAround, setInertAttributes } from "../../common/inert.js"

export class FocusTrapController implements ReactiveController {
  private inertElements: Element[] = []

  constructor(private host: ReactiveControllerHost & HTMLElement) {
    host.addController(this)
  }

  hostDisconnected() {
    this.release()
  }

  trap() {
    const elements = getElementsAround(this.host)

    setInertAttributes(elements, true)
    this.inertElements = elements
  }

  release() {
    setInertAttributes(this.inertElements, false)
    this.inertElements = []
  }
}
